import { getItemNavigationUrl } from '@/modules/layout/platformNavigation/utils/navigationUtils';

export const PULSE_FEATURE_FLAGS = ['pkg.ai.bizai_pulse', 'rollout.ai.bizai_pulse'];

export const isPulseEnabled = (hasFeature) => PULSE_FEATURE_FLAGS.every((flag) => hasFeature(flag));

const PULSE_MENU_ITEM_NAME = 'home';
const PULSE_MENU_ITEM_PATHS = ['/home', '/dashboard'];

const normalizeMenuItemPath = (path) => (typeof path === 'string'
  ? path.replace(/^\/app(?=\/|$)/, '').split('?')[0].replace(/\/$/, '')
  : '');

export const isPulseMenuItem = (item, hasFeature) => {
  if (!item || !isPulseEnabled(hasFeature)) return false;
  const path = normalizeMenuItemPath(getItemNavigationUrl(item));
  if (path) return PULSE_MENU_ITEM_PATHS.includes(path);
  return item.name === PULSE_MENU_ITEM_NAME;
};
